/**
 *  获取系统信息
 * @returns
 */
import store from "../store";
import { GETSYSTEM } from "./SystemFuns";

export const getSystemInfo = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
     /**
       *  如果是鸿蒙包 调用window.getSystem.call 则会返回 HarmonyOS 接口走鸿蒙 不是鸿蒙包 则拦截错误 接口走安卓
       */
      try{
        if(window.getSystem&&window.getSystem.call){
          let result = window.getSystem.call('{"webAction":"getSystem"}'); // 这里只能这样调 不然第一次进来会报错 原因不详 好像是Vuex没初始化完成
          if (result == "HarmonyOS") {
            return "HOM";
          }else{
            return "Android";
          }
        }else{
          return "Android";
        }
      }catch (error) {
        // 在Android系统中运行
        return "Android";
      }
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    // 在iOS系统中运行
    return "IOS";
  } else {
    // 其他系统
    return "unKnow";
  }
};

/**
 *  设置系统信息
 */
export const setSystemInfo = () => {
  let System = getSystemInfo();
  store.commit("app/setPhoneModel", System);
};



// WEBPACK FOOTER //
// ./src/systemFolder/utils.js